var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Functions = OCS.WxBriefing.Functions || {};
OCS.WxBriefing.Functions.define_ui_mobile_class = function (ui_class) {
    return new Class({
        Extends: ui_class,
        options: {
            ga_category: 'mobile'
        },
        init_events: function () {
            this.parent();
            var em = OCS.WxBriefing.Functions.get_event_manager();
            if (this.events.mobile_resize) {
                em.unsubscribe(this.events.mobile_resize);
            }
            this.events.mobile_resize = em.subscribe({"event_name": "resize", "callback": this.mobile_resize.bind(this), item: $(window), "specific_event": true});
        },
        init_buttons: function () {
            OCS.WxBriefing.Functions.get_about_manager();
            this.init_change_playform_button();
            this.init_logout_button();
        },
        init_mobile_orientation_fix: function () {
            if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
                var viewportmeta = document.querySelectorAll('meta[name="viewport"]')[0];
                if (viewportmeta) {
                    viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0';
                    document.body.addEventListener('gesturestart', function () {
                        viewportmeta.content = 'width=device-width, minimum-scale=0.25, maximum-scale=1.6';
                    }, false);
                }
            }
            this.mobile_resize();
        },
        start: function () {
            this.parent();
            this.init_mobile_orientation_fix();
        },
        mobile_resize: function (e) {
            var width = $(window).width();
            var height = $(window).height();
            if ((width / height) < 1) {
                $(document.body).removeClass('landscape').addClass('portrait');
            } else {
                $(document.body).removeClass('portrait').addClass('landscape');
            }
        }
    }); // End OCS.WxBriefing.Classes.UIMobile
};